import { readFile, writeFile } from 'node:fs/promises';
import { join } from 'node:path';
import { globby } from 'globby';
import { normalizeGlobbyPattern } from '../dev-center/components/path.js';

export const replacePlaceholder = async ({
  directory,
  cwd,
  replacements,
}: {
  directory: string;
  cwd: string;
  replacements: Array<[string, string]>;
}) => {
  const JS_BUILD_FILES = join(directory, '**', '*.{js,js.map,mjs,mjs.map}');

  const filePaths = await globby(normalizeGlobbyPattern(JS_BUILD_FILES), {
    cwd,
  });

  for (const filePath of filePaths) {
    let file = await readFile(filePath, 'utf-8');

    for (const [placeholder, value] of replacements) {
      file = file.replaceAll(placeholder, value.replaceAll('\n', '\\n'));
    }

    await writeFile(filePath, file, 'utf-8');
  }

  // return a function to try and roll back the changes
  return async () => {
    for (const filePath of filePaths) {
      let file = await readFile(filePath, 'utf-8');

      for (const [placeholder, value] of replacements) {
        file = file.replaceAll(value, placeholder);
      }

      await writeFile(filePath, file, 'utf-8');
    }
  };
};
